export const COLLAPSED_WIDTH = 0;
export const NORMAL_WIDTH = 260;
export const NORMAL_WIDTH_ON_COLLAPSE = 180;
export const SM_ML_ADJ = 0;
